var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2233",
    fillRule: "evenodd",
    d: "M8.244 10.782L.974 2.397A1 1 0 0 1 1.73.742h14.54a1 1 0 0 1 .756 1.655l-7.27 8.385a1 1 0 0 1-1.512 0z"
  })));
}

export default __webpack_public_path__ + "media/explore/images/icon_drop-1e64bb512a8263ecf37e38d98350329d.svg";
export { SvgIconDrop as ReactComponent };